
import { NigmaMessage } from "@/model/Message";
import { UPDATE_COMPOSER_HEIGHT } from "@/store";
import { Options, Vue } from "vue-class-component";
import HintButton from "./HintButton.vue";

@Options({
  components: {
    HintButton,
  },
  data() {
    return {
      msg: "",
    };
  },
  computed: {
    options() {
      const messages: NigmaMessage[] = this.$store.state.messageHistory;
      return messages.length > 0 ? messages[messages.length - 1].options : null;
    },
    customKeyboard() {
      const messages: NigmaMessage[] = this.$store.state.messageHistory;
      return messages.length > 0
        ? messages[messages.length - 1].customKeyboard
        : null;
    },
    showCustomKeyboard() {
      return this.$store.state.showCustomKeyboard;
    },
  },
  methods: {
    updateMsg(e: any) {
      this.msg = e.target!.innerText;
    },
    sendMessage(message: string) {
      const trimmedMsg = message.trim();
      if (trimmedMsg.length > 0) {
        this.msg = "";
        this.$store.dispatch("sendMessage", trimmedMsg);
      }
    },
  },
  updated() {
    this.$store.commit(UPDATE_COMPOSER_HEIGHT, this.$el.offsetHeight);
  },
  mounted() {
    this.$store.commit(UPDATE_COMPOSER_HEIGHT, this.$el.offsetHeight);
  },
})
export default class MessageComposer extends Vue {}
